import VehiclesGroupedReport from "./VehiclesGroupedReport";

export default function VehiclesByState() {
  return (
    <VehiclesGroupedReport
      title="Vehicles by State"
      subtitle="Active fuel access registrations grouped by the state of the user's retail outlet."
      dimension="state"
      dropdownLabel="State"
      dropdownPlaceholder="All states"
      dropdownApiPath="/master/states"
    />
  );
}
